var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.SelectSynchronizedFields"),
        width: _vm.$selectByLang("500px", "584px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", [
        _c("fieldset", [
          _c("legend", [_vm._v(_vm._s(_vm.$t("Message.SynchronizedFields")))]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "padding-left": "30px"
              }
            },
            [
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "ContainerSize" },
                  model: {
                    value: _vm.containerInfo.containerSize,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "containerSize", $$v)
                    },
                    expression: "containerInfo.containerSize"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))]
              ),
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "ContainerType" },
                  model: {
                    value: _vm.containerInfo.containerType,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "containerType", $$v)
                    },
                    expression: "containerInfo.containerType"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerType")))]
              ),
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "ContainerNo" },
                  model: {
                    value: _vm.containerInfo.containerNo,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "containerNo", $$v)
                    },
                    expression: "containerInfo.containerNo"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerNo")))]
              ),
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "ContainerWeight" },
                  model: {
                    value: _vm.containerInfo.containerWeight,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "containerWeight", $$v)
                    },
                    expression: "containerInfo.containerWeight"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerWeight")))]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "row",
                "padding-left": "30px"
              }
            },
            [
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "SealNo" },
                  model: {
                    value: _vm.containerInfo.sealNo,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "sealNo", $$v)
                    },
                    expression: "containerInfo.sealNo"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.SealNo")))]
              ),
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "itemCount" },
                  model: {
                    value: _vm.containerInfo.itemCount,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "itemCount", $$v)
                    },
                    expression: "containerInfo.itemCount"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.itemCount")))]
              ),
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "GrossWeight" },
                  model: {
                    value: _vm.containerInfo.grossWeight,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "grossWeight", $$v)
                    },
                    expression: "containerInfo.grossWeight"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.GrossWeight")))]
              ),
              _c(
                "el-checkbox",
                {
                  style: _vm.$selectByLang("width: 64px", "width: 85px"),
                  attrs: { no: "Cubage" },
                  model: {
                    value: _vm.containerInfo.cubage,
                    callback: function($$v) {
                      _vm.$set(_vm.containerInfo, "cubage", $$v)
                    },
                    expression: "containerInfo.cubage"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cubage")))]
              )
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticStyle: {
              "word-wrap": "break-word",
              "white-space": "normal",
              "font-family": "sans-serif",
              "margin-bottom": "8px",
              "margin-left": "24px"
            }
          },
          [
            _c(
              "span",
              { staticStyle: { "font-size": "12px", "line-height": "18px" } },
              [
                _vm._v(
                  _vm._s(_vm.$t("SeaExport.AttentionForSynchronizedContainer"))
                )
              ]
            )
          ]
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "cancel" }, on: { click: _vm.close } },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }